import React, { useEffect, useMemo, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

import * as PR from "../../prime-modules/index";
import Layout from "../../components/layout/Layout";
import { useToast } from "../../context/ToastContext";
import { initializeKycVerificationApi } from "../../services/api";
import { displayBase64 } from "../../utils/reuse";
import "./Kyc.scss";

const KycVerification = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [kycData, setKycData] = useState(null);

  const { myAccount: account } = useSelector(
    (state) => state.language?.activelang,
  );

  const copy = useMemo(
    () => ({
      title: account?.ACTN0141,
      loading: account?.ACTN0142,
      missingUrl:
        account?.ACTN0147,
      initError:
        account?.ACTN0130,
      done: account?.ACTN0132,
    }),
    [account],
  );

  const { mutate, isLoading } = useMutation(initializeKycVerificationApi, {
    onSuccess: (result) => {
      const sessionUrl = result?.url;
      if (!sessionUrl) {
        showToast("error", copy.missingUrl);
        navigate("/kyc-details", { replace: true });
        return;
      }
      
      if (isMobile) {
        window.location.href = sessionUrl;
      } else {
        setKycData(result);
      }
    },
    onError: (error) => {
      showToast("error", error?.message || copy.initError);
      navigate("/kyc-details", { replace: true });
    },
  });

  useEffect(() => {
    mutate();
  }, [mutate]);

  const qrCodeSrc = useMemo(() => {
    if (!kycData) return null;

    const qr = kycData?.qr_code;
    if (qr) {
      if (qr.startsWith("data:") || qr.startsWith("http://") || qr.startsWith("https://")) {
        return qr;
      }
      return displayBase64(qr);
    }

    return null;
  }, [kycData]);

  return (
    <Layout>
      <section className="kyc-section">
        {!isMobile && kycData ? (
          <div className="kyc-status-card kyc-qr-card">
            <h1>{copy.title}</h1>
            <p className="kyc-qr-description">
              {account?.ACTN0148 || "Please scan the QR code using your mobile device to complete your identity verification."}
            </p>
            <div className="kyc-qr-wrapper">
              {qrCodeSrc ? (
                <PR.Image
                  src={qrCodeSrc}
                  alt="Scan the QR Code"
                  className="kyc-qrcode"
                  preview={false}
                />
              ) : (
                <i className="pi pi-spin pi-spinner kyc-icon kyc-neutral"></i>
              )}
            </div>
            <PR.Button
              label={copy.done}
              className="signup-button kyc-primary-button"
              onClick={() => navigate("/kyc-details")}
            />
          </div>
        ) : (
          <div className="kyc-status-card kyc-loading-card">
            <i className="pi pi-spin pi-spinner kyc-icon kyc-neutral"></i>
            <h1>{copy.title}</h1>
            <p>{copy.loading}</p>
            <PR.Button
              label={copy.done}
              className="p-button-text done-button"
              onClick={() => navigate("/kyc-details")}
              disabled={isLoading}
            />
          </div>
        )}
      </section>
    </Layout>
  );
};

export default KycVerification;
